const { protocol, appName } = require('~/root/package.json');

export enum CFD_EVENTS {
  CREATE_CFD = 'CFD:CREATE_CFD',
  SET_FULLSCREEN = 'CFD:SET_FULLSCREEN',
  SET_POSITION = 'CFD:SET_POSITION',
  CLOSE_CFD = 'CFD:CLOSE_CFD',
  SET_DISPLAY = 'CFD:SET_DISPLAY',
  SET_BOUNDS = 'CFD:SET_BOUNDS',
  GET_DISPLAYS = 'CFD:GET_DISPLAYS',
  SHOW_OUTLINE_WINDOW = 'CFD:SHOW_OUTLINE_WINDOW',
  CLOSE_OUTLINE_WINDOW = 'CFD:CLOSE_OUTLINE_WINDOW',
  DISPLAY_CHANGED = 'CFD:DISPLAY_CHANGED',
  ALLOW_SINGLE_SCREEN = 'CFD:ALLOW_SINGLE_SCREEN',
  GET_ALLOW_SINGLE_SCREEN = 'CFD:GET_ALLOW_SINGLE_SCREEN',
  NOTIFY_CFD_DISCONNECT = 'CFD:NOTIFY_CFD_DISCONNECT',
  DESKTOP_CAPTURER_GET_SOURCES = 'CFD:DESKTOP_CAPTURER_GET_SOURCES',
}

export enum PRINTER_EVENTS {
  SCAN_FOR_PRINTERS = 'PRINTER:SCAN_FOR_PRINTERS',
  SCAN_COMPLETE = 'PRINTER:SCAN_COMPLETE',
  SCAN_FAILED = 'PRINTER:SCAN_FAILED',
  SCAN_REQUIRES_ADMINISTRATOR = 'PRINTER:SCAN_REQUIRES_ADMINISTRATOR',
  CANCEL_PRINTERS_SCAN = 'PRINTER:CANCEL_PRINTERS_SCAN',
  INSTALL_WINDOWS_DRIVERS = 'PRINTER:INSTALL_WINDOWS_DRIVERS',
  PRINT = 'PRINTER:PRINT',
  COMMAND = 'PRINTER:COMMAND',
  PRINT_TEST = 'PRINTER:PRINT_TEST',
  PRINT_COMPLETED = 'PRINTER:PRINT_COMPLETED',
  PRINT_ERROR = 'PRINTER:PRINT_ERROR',
  UPDATE_DEFAULT_PRINTERS = 'PRINTER:UPDATE_DEFAULT_PRINTERS',
  DELETE_DEFAULT_PRINTERS = 'PRINTER:DELETE_DEFAULT_PRINTERS',
  ADD_DEFAULT_PRINTER_BY_IP = 'PRINTER:ADD_DEFAULT_PRINTER_BY_IP',
  ADD_PRINTER_BY_IP = 'PRINTER:ADD_PRINTER_BY_IP',
  OPEN_CASH_DRAWER = 'PRINTER:OPEN_CASH_DRAWER',
  DISCONNECT_LIST_PRINTERS = 'PRINTER:DISCONNECT_LIST_PRINTERS',
}

export enum HUB_EVENTS {
  CLOSING = 'HUB:CLOSING',
  CONFIRM_QUIT = 'HUB:CONFIRM_QUIT',
  OPEN_EXTERNAL_URL = 'HUB:OPEN_EXTERNAL_URL',
  KONAMI_CODE_ACTIVATED = 'HUB:KONAMI_CODE_ACTIVATED',
  TRIGGER_RESTART = 'HUB:TRIGGER_RESTART',
  HYDRATE = 'HUB:HYDRATE',
  QUERY_PARAMS = 'HUB:QUERY_PARAMS',
  LICENSE_UPDATED = 'HUB:LICENSE_UPDATED',
  GET_LICENSE = 'HUB:GET_LICENSE',
  GET_LICENSE_BODY = 'HUB:GET_LICENSE_BODY',
  LICENSE_BODY_READY = 'HUB:LICENSE_BODY_READY',
  LICENSE_CONFIRM = 'HUB:LICENSE_CONFIRM',
  LICENSE_DECLINE = 'HUB:LICENSE_DECLINE',
  CLOSE_LICENSE = 'HUB:CLOSE_LICENSE',
  OPEN_PREFERENCES = 'HUB:OPEN_PREFERENCES',
  LANGUAGE_CHANGED = 'HUB:LANGUAGE_CHANGED',
  DATA_RESET = 'HUB:DATA_RESET',
  LAUNCH_ON_STARTUP_CHANGED = 'HUB:LAUNCH_ON_STARTUP_CHANGED',
  AUTO_UPDATES_ENABLED_CHANGED = 'HUB:AUTO_UPDATES_ENABLED_CHANGED',
  CASH_DRAWER_CABLE = 'HUB:CASH_DRAWER_CABLE',
  LABEL_PRINTER_RESETTING_CHANGED = 'HUB:LABEL_PRINTER_RESETTING_CHANGED',
  NOTIFICATIONS_SETTINGS_CHANGED = 'HUB:NOTIFICATIONS_SETTINGS_CHANGED',
  DEBUG_LOGS_SETTINGS_CHANGED = 'HUB:DEBUG_LOGS_SETTINGS_CHANGED',
  DEBUG_LOGS_CLEANUP = 'HUB:DEBUG_LOGS_CLEANUP',
  DEBUG_LOGS_OPEN_FOLDER = 'HUB:DEBUG_LOGS_OPEN_FOLDER',
  CONFIG_JSON_OPEN_FOLDER = 'HUB:CONFIG_JSON_OPEN_FOLDER',
  PRINT_SETTINGS_CHANGED = 'HUB:PRINT_SETTINGS_CHANGED',
  LOG = 'HUB:LOG',
  TRAY_ICON_UPDATE = 'HUB:TRAY_ICON_UPDATE',
  LOCAL_SERVER_CONNECTION_CHANGED = 'HUB:LOCAL_SERVER_CONNECTION_CHANGED',
  LOCAL_SERVER_PUBLISH = 'HUB:LOCAL_SERVER_PUBLISH',
  LOCAL_SERVER_RECEIVE = 'HUB:LOCAL_SERVER_RECEIVE',
  RELAY_PUBLISH = 'HUB:RELAY_PUBLISH',
}

export enum ELECTRON_EVENTS {
  REDUX_ACTION = 'redux-action',
  READY = 'ready',
  ACTIVATE = 'activate',
  BEFORE_QUIT = 'before-quit',
  WILL_QUIT = 'will-quit',
  NEW_WINDOW = 'new-window',
  WINDOW_ALL_CLOSED = 'window-all-closed',
  SECOND_INSTANCE = 'second-instance',
  OPEN_URL = 'open-url',
  CLOSED = 'closed',
  CLOSE = 'close',
  ENTER_FULL_SCREEN = 'enter-full-screen',
  LEAVE_FULL_SCREEN = 'leave-full-screen',
  DISPLAY_ADDED = 'display-added',
  READY_TO_SHOW = 'ready-to-show',
  DISPLAY_METRICS_CHANGED = 'display-metrics-changed',
  DISPLAY_REMOVED = 'display-removed',
  MINIMIZE = 'minimize',
  RESTORE = 'restore',
  UNCAUGHT_EXCEPTION = 'uncaughtException',
  PAGE_TITLE_UPDATED = 'page-title-updated',
  CHECKING_FOR_UPDATE = 'checking-for-update',
  UPDATE_AVAILABLE = 'update-available',
  UPDATE_NOT_AVAILABLE = 'update-not-available',
  DOWNLOAD_PROGRESS = 'download-progress',
  UPDATE_DOWNLOADED = 'update-downloaded',
  UPDATE_ERROR = 'update-error',
  UPDATE_RESTART = 'update-restart',
  CHECK_FOR_UPDATES = 'check-for-updates',
}

export const PROTOCOL = protocol;
export const APP_NAME = appName;
